import {LitElement, css, html} from "lit";

export class AuiCheckmark extends LitElement {

	static get properties() {
		return {
			/**
			 * small|normal|medium|large
			 */
			size: { type: String, reflect: true },

			checked: { type: Boolean, reflect: true },
			isDisabled: { type: Boolean, attribute: "disabled", reflect: true },
		};
	}

	static get styles() {
		return css`
			/* Checkmark animations */
			@-webkit-keyframes checkmark-expand {
				0% { -webkit-transform: scale(0, 0) rotate(45deg); }
				100% { -webkit-transform: scale(1, 1) rotate(45deg); }
			}
			
			@keyframes checkmark-expand {
				0% { transform: scale(0, 0) rotate(45deg); }
				100% { transform: scale(1, 1) rotate(45deg); }
			}
			
			:host {
				--aui-checkmark-size: 18px;
				
				position: relative;
				display: inline-block;
				width: var(--aui-checkmark-size);
				height: var(--aui-checkmark-size);
				outline: none;
			}
			
			:host([size="small"]) { --aui-checkmark-size: 16px; }
			/*:host([size="normal"]) { --aui-checkmark-size: 18px; }*/
			:host([size="medium"]) { --aui-checkmark-size: 20px; }
			:host([size="large"]) { --aui-checkmark-size: 22px; }
			
			.checkmark {
				position: absolute;
				width: 25%;
				height: 50%;
				border-style: solid;
				border-top: none;
				border-left: none;
				border-right-width: calc(2/15 * var(--aui-checkmark-size));
				border-bottom-width: calc(2/15 * var(--aui-checkmark-size));
				border-color: var(--aui-checkmark-color, var(--primary-color));
				-webkit-transform-origin: 60% 118%;
				transform-origin: 60% 118%;
			}
			
			/* Not Checked State */
			:host(:not([checked])) .checkmark { display: none; }
			
			/* Checked State */
			:host([checked]) .checkmark {
				-webkit-animation: checkmark-expand 140ms ease-out forwards;
				animation: checkmark-expand 140ms ease-out forwards;
			}
			
			/* Disabled & Checked State */
			/*:host([disabled][checked]) .checkmark {
				border-color: var(--aui-checkmark-disabled-color, var(--primary-text-color));
			}*/
			
			/* Disabled State */
			:host([disabled]) .checkmark {
				border-color: var(--aui-checkmark-disabled-color, var(--primary-text-color));
			}
		`;
	}

	render() {
		return html`<div class="checkmark"></div>`;
	}

}

export default AuiCheckmark;

customElements.define("aui-checkmark", AuiCheckmark);